var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxoutlinefolderUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,22.8c-4.4,0-5.8-1.3-5.8-5.8V7c0-4.4,1.3-5.8,5.8-5.8h1.5c1.8,0,2.3,0.6,3,1.5l1.5,2 c0.3,0.4,0.4,0.5,1,0.5h3c4.4,0,5.8,1.3,5.8,5.8v6c0,4.4-1.3,5.8-5.8,5.8H7z M2.8,7v10c0,3.6,0.7,4.2,4.2,4.2h10 c3.6,0,4.2-0.7,4.2-4.2v-6c0-3.6-0.7-4.2-4.2-4.2h-3c-1.3,0-1.7-0.4-2.2-1.1l-1.5-2C9.8,3,9.6,2.8,8.5,2.8H7l0,0 C3.4,2.8,2.8,3.4,2.8,7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2,6.4V5c0-1.6-0.7-2.2-2.2-2.2H8 C7.6,2.8,7.2,2.4,7.2,2S7.6,1.2,8,1.2h9c2.4,0,3.8,1.3,3.8,3.8v1.4c0,0.4-0.3,0.8-0.8,0.8S19.2,6.8,19.2,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9,13.6c-1.4,0-2.5-1.2-2.5-2.5 c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5C14.4,12.4,13.3,13.5,11.9,13.6C11.9,13.6,11.9,13.6,11.9,13.6 C11.9,13.6,11.9,13.6,11.9,13.6z M10.9,11.1c0,0.6,0.4,1,1,1c0,0,0,0,0.1,0c0.5,0,0.9-0.5,0.9-1c0-0.6-0.5-1-1-1 C11.3,10,10.9,10.5,10.9,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,18.6c-0.7-0.4-1.1-1.1-1.1-1.8 s0.4-1.3,1.1-1.8c1.3-0.9,3.5-0.9,4.8,0c0.7,0.4,1.1,1.1,1.1,1.8c0,0.7-0.4,1.3-1.1,1.8c-0.7,0.4-1.5,0.7-2.4,0.7 C11.1,19.2,10.2,19,9.5,18.6z M10,16.8c0,0.2,0.1,0.4,0.4,0.5c0.8,0.6,2.3,0.6,3.1,0c0.2-0.2,0.4-0.4,0.4-0.5s-0.1-0.4-0.4-0.5 c-0.8-0.5-2.3-0.5-3.1,0C10.1,16.4,10,16.6,10,16.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxoutlinefolderUser);
export default __webpack_public_path__ + "static/media/vuesaxoutlinefolder-user.824ead61b9336c1a336365fcbedc8298.svg";
export { ForwardRef as ReactComponent };